<template>
<div>
      <div class="h-outTabs">
        <ejs-tab ref="tabObj" id="tab_orientation" heightAdjustMode="Auto" :selected='selected'>
          <e-tabitems>
            <e-tabitem :header="headerText0" content="#idv1"></e-tabitem>
            <e-tabitem :header="headerText1" content="#idv2"></e-tabitem>
          </e-tabitems>
        </ejs-tab>
      </div>
      <div id="idv1" style="display: none">
        <VerlibList ref='missionList'></VerlibList>
      </div>
      <div id="idv2" style="display: none">
        <PatchVerlibList ref='missionLogs'></PatchVerlibList>
      </div>
</div>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import VerlibList from "../../components/software/VerlibList";
import PatchVerlibList from "../../components/software/PatchVerlibList";

export default {
  name: "MissionManager",
  data: function() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('System.systemManager')}/${this.$t('System.missManager')}/${this.$t('System.systemMiss')}`},
      headerText0: { text: `${this.$t('Topo.bStationEdition')}` },
      headerText1: { text: `${this.$t('Topo.patchVersion')}` },
      missionClass: 0, // 0 系统任务 1 自定义任务
      sysOrCustom: 0
    };
  },
  components: {
    BasicLayout,
    VerlibList,
    PatchVerlibList
  },
  methods: {
    setBasicTitle() {
      let id = this.$route.params.id;
      if (id === "1") {
        this.right.crumb = `${this.$t('System.systemManager')}/${this.$t('System.missManager')}/${this.$t('System.systemMiss')}`;
        this.sysOrCustom = 0;
      } else {
        this.right.crumb = `${this.$t('System.systemManager')}/${this.$t('System.missManager')}/${this.$t('System.customMiss')}`;
        this.sysOrCustom = 1;
      }
      this.$refs.missionList.init(this.sysOrCustom);
      this.$refs.missionLogs.init(this.sysOrCustom);
    },
    selected(args){
      const index = args.selectedIndex;
      if (index === 0) {
       // this.$refs.missionList.getMissionList();
      } else {
       // this.$refs.missionLogs.getMissionLogs();
      }
    }
  },
  watch: {
    $route(to, from) {
      this.setBasicTitle();
    }
  },
  mounted() {
   // this.setBasicTitle();
  }
};
</script>

<style>
</style>
